import { AppDispatch } from '../index';
import API from '@/app/lib/axios';

import { urls } from '../urls';

import { CompanySlice } from '../controllers/CompanySlice';
import { CompaniesSlice } from '@/shared/store/controllers/CompaniesSlice';

import { toast } from 'react-toastify';
import { GridInfo } from '@/shared/models/company.model';
import { GridURLParam } from '@/shared/models/grid.model';
import { parseURLParam } from '@/shared/helpers/gridData';


export const loadCompany = () => async (dispatch: AppDispatch) => {
  try {
    const response = await API.get(`${urls.accountCompany}`);
    dispatch(CompanySlice.actions.loadCompanies(response));
  } catch (err: any) {
    dispatch(CompanySlice.actions.setErrorCompanies(err.message));
    console.error(`Error upon Load Companies: ${err}`);
  }
};

export const loadCompanyById = (id: string) => async () => {
  try {
    const URL = urls.companyById.replace(':id', `${id}`);
    const response: any = await API.get(`${URL}`);
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Company By Id: ${err}`);
  }
};

export const updateCompany = (data: GridInfo) => async () => {
  try {
    return await API.patch(`${urls.accountCompany}`, data);
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Updating Company By: ${err}`);
  }
};

export const createCompany = (data: GridInfo) => async () => {
  try {
    return await API.post(`${urls.companies}`, data);
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Updating Company By: ${err}`);
  }
};

export const loadTerminalById = (terminalId: number) => async () => {
  try {
    const URL = urls.terminalById.replace(':id', `${terminalId}`);
    const response: any = await API.get(`${URL}`);
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Terminal: ${err}`);
  } finally {
    console.error('Error upon Getting Terminal');
  }
};

export const createTerminal = (terminal: any) => async () => {
  try {
    const URL = urls.terminals;
    const response: any = await API.post(`${URL}`, terminal);
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Create Terminal: ${err}`);
  } finally {
    console.error('Error upon Create Terminal');
  }
};

export const updateTerminal = (terminalId: number, terminal: any) => async () => {
  try {
    const URL = urls.terminalById.replace(':id', `${terminalId}`);
    const response: any = await API.put(`${URL}`, terminal);
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Update Terminal: ${err}`);
  } finally {
    console.error('Error upon Update Terminal');
  }
};

export const loadCompanies = (params?: GridURLParam | any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(CompaniesSlice.actions.setLoadingCompanies(true));
    let URL = urls.getCompanies;
    if (params && Object.keys(params).length !== 0) {
      URL += parseURLParam(params);
    }
    const response: any = await API.get(`${URL}`);
    dispatch(CompaniesSlice.actions.loadCompanies(response));
    return response;
  } catch (err: any) {
    dispatch(CompaniesSlice.actions.setErrorCompanies(err.message));
    console.error(`Error upon Load Companies: ${err}`);
  } finally {
    dispatch(CompaniesSlice.actions.setLoadingCompanies(false));
    dispatch(CompaniesSlice.actions.setRefreshData(false));
  }
};

export const setActiveCompany = (companyId: any) => async () => {
  try {
    const URL = urls.setCompany;
    const response: any = await API.post(`${URL}`, {company_id: companyId});
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error set active company: ${err}`);
  }
};